<div class="custom-modal">
  <div class="custom-modal-body">
    <app-data-table
      [data]="users"
      [totalRecords]="users.length"
      [columns]="[
        { field: 'username', header: 'username' | translate },
        { field: 'email', header: 'email' | translate }
      ]"
    ></app-data-table>
  </div>
</div>